/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const stretchWide = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 9v6h14V9H5zm11-4.8H8v1.5h8V4.2zM8 19.8h8v-1.5H8v1.5z" />
	</SVG>
);

export default stretchWide;
